import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './controller_edit.routes';

import SaConfigService from '../../../../components/api/sa_config/sa_config.service';
import DistStockService from '../../../../components/api/dist_stock/dist_stock.service';
import ControllerConfigService from '../../../../components/api/controller_config/controller_config.service';
import ZipSearchLogic from '../../../../components/logic/zip-search/zip-search.logic';

class OemControllerDeviceEditController {
  /*@ngInject*/
  constructor($state, $stateParams, $scope, $timeout, $mdDialog, SaConfigService, DistStockService, ControllerConfigService, ZipSearchLogic) {
    this.ControllerConfigService = ControllerConfigService;
    this.DistStockService = DistStockService;
    this.SaConfigService = SaConfigService;
    this.ZipSearchLogic = ZipSearchLogic;
    this.id = $stateParams.id;
    this.company_id = $stateParams.company_id;
    this.$state = $state;
    this.$mdDialog = $mdDialog;

    this.dialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '変更しますか？',
        ok: '変更する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '変更しました',
        ok: 'OK'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'エラーが発生しました',
        content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
        ok: 'OK'
      })
    };

    $scope.$watch('$ctrl.deviceConfig.zip_code', current => {
      if (current && !this.deviceConfig.location) {
        this.ZipSearchLogic.get(current).then(address => {
          $timeout(() => {
            this.deviceConfig.location = address.prefecture_name + address.city_name + address.town_name;
          });
        });
      }
    });
  }

  $onInit() {
    this.ControllerConfigService.oem_api.show({id: this.id}).$promise
      .then(response => {
        this.deviceConfig = response;
        this.currentDistId = this.deviceConfig.distribution_id;
        this.currentReadingId = this.deviceConfig.reading_device_id = this.deviceConfig.reading_device_id + '';

        return this.DistStockService.oem_api.index({service_type: 'tss'}).$promise;
      })
      .catch(err => {
        if (err.status === 404 || err.status === 403) {
          this.$state.go('oem_main.oem_home');
        }
        return Promise.reject();
      })
      .then(response => {
        let stocks = response.dist_stocks;
        stocks.unshift(this.deviceConfig.distribution_id);
        this.deviceStocks = stocks;
      });

    this.SaConfigService.oem_api.index({company_id: this.company_id}, response => {
      this.readingDevices = response;
    }, err => {
      if (err.status === 404 || err.status === 403) {
        this.$state.go('oem_main.oem_home');
      }
    });
  }

  showConfirm(deviceConfig, ev) {
    this.$mdDialog.show(this.dialog.confirm.targetEvent(ev))
      .then(() => {
        this.ControllerConfigService.oem_api.update(
          deviceConfig,
          (okResponse) => { this.$mdDialog.show(this.dialog.success); },
          (errResponse) => { this.$mdDialog.show(this.dialog.error.content(errResponse.data.message)); }
        );
      });
  }
}

export default angular.module('leptonApp.oemControllerDeviceEdit', [uiRouter, SaConfigService, DistStockService, ControllerConfigService, ZipSearchLogic])
  .config(routing)
  .component('oemControllerDeviceEdit', {
    template: require('./controller_edit.html'),
    controller: OemControllerDeviceEditController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/oem/device_config/controller_edit/controller_edit.component.js